import BlockRenderer from "@/cms/BlockRenderer";
import { useSiteContent } from "@/cms/useSiteContent";

export default function ContactUs() {
  const { blocks } = useSiteContent("contact-us");

  return (
    <div className="min-h-screen bg-[#0B2421]">
      <BlockRenderer blocks={blocks} />
    </div>
  );
}
